import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { Building } from 'lucide-react';

const InfoLicitaciones = () => {
  const { isAdmin } = useAuth();
  return (
    <div className="doc-page-container" style={{ '--doc-color': '#1565c0', '--doc-bg-color': '#e3f2fd' }}>
      <div className="doc-page-card">
        <div className="doc-page-header">
          <div className="doc-page-icon"><Building size={48} /></div>
          <h2 className="doc-page-title">Licitaciones</h2>
        </div>
        <p className="doc-page-text">Convocatorias y pliegos de licitaciones públicas y privadas.</p>
        <FileManager tableName="licitaciones_files" folderName="licitaciones" bucketName="licitaciones" isAdmin={isAdmin} />
      </div>
    </div>
  );
};
export default InfoLicitaciones;